import './App.css';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import zhHK from "antd/locale/zh_HK";
import Index from "./pages/index";
import About from "./pages/about/about";
import Contact from "./pages/contact/contact";
import Portrait from "./pages/portrait/portrait";
import Wedding from "./pages/wedding/wedding";
import Event from "./pages/event/event";
import Commercial from "./pages/exhibitions/exhibitions";
import Landscape from "./pages/scenery/scenery";
import Destination from "./pages/destination/destination";
import ReactGA from 'react-ga4';
import PhotoOverlay from "./components/PhotoOverlay/PhotoOverlay";
import Creative from './pages/creative/creative';
import Fashion from './pages/fashion/fashion';
import Pets from "./pages/pets/pets";
import CreatorPartnerships from "./pages/creatorPartnerships/CreatorPartnerships";
import Delivery from "./pages/delivery/Delivery";
import DeliveryAdmin from "./pages/delivery/DeliveryAdmin";
import DeliveriesManage from "./pages/delivery/DeliveriesManage";
import DeliveryShare from "./pages/delivery/DeliveryShare";
import Selection from "./pages/selection/Selection";
import SelectionCart from "./pages/selection/SelectionCart";
import SelectionAdmin from "./pages/selection/SelectionAdmin";
import SelectionManage from "./pages/selection/SelectionManage";
import SelectionResults from "./pages/selection/SelectionResults";
import VideoReview from "./pages/videoReview/VideoReview";
import VideoReviewAdmin from "./pages/videoReview/VideoReviewAdmin";
import VideoReviewManage from "./pages/videoReview/VideoReviewManage";
import VideoReviewResults from "./pages/videoReview/VideoReviewResults";
import VideoReviewAudit from "./pages/videoReview/VideoReviewAudit";
import FeedbackResults from "./pages/feedback/FeedbackResults";
import QuoteBuilder from "./pages/quote/QuoteBuilder";
import AcornQuotePage from "./acornQuote/AcornQuotePage";
import Admin from "./pages/admin/Admin";
import Bookings from "./pages/booking/Bookings";
import BookingView from "./pages/booking/BookingView";
import RequireAdmin from "./components/auth/RequireAdmin";
import RetouchRequireAdmin from "./components/retouchReview/RetouchRequireAdmin";
import RetouchReviewAdmin from "./pages/retouchReview/RetouchReviewAdmin";
import RetouchReviewManage from "./pages/retouchReview/RetouchReviewManage";
import RetouchReview from "./pages/retouchReview/RetouchReview";
import RetouchReviewAudit from "./pages/retouchReview/RetouchReviewAudit";
import RetouchReviewUpload from "./pages/retouchReview/RetouchReviewUpload";
import FileTransferAdmin from "./pages/fileTransfer/FileTransferAdmin";
import FileTransferManage from "./pages/fileTransfer/FileTransferManage";
import FileTransferSession from "./pages/fileTransfer/FileTransferSession";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import BackToTop from "./components/BackToTop/BackToTop";
import PostHogPageView from "./components/analytics/PostHogPageView";
import { appTheme } from "./theme";
import { LanguageProvider, useLanguage } from "./i18n";
import { WhiteLabelProvider } from "./whiteLabel/useWhiteLabel";

function AppContent() {
    const { locale } = useLanguage();
    const TRACKING_ID = "G-GC2ETZLFRK";
    ReactGA.initialize(TRACKING_ID);

    return (
        <ConfigProvider
            theme={appTheme}
            locale={locale === "zh" ? zhCN : locale === "yue" ? zhHK : enUS}
        >
            <Router>
                <WhiteLabelProvider>
                    <ScrollToTop />
                    <BackToTop />
                    <PostHogPageView />
                    <Routes>
                    <Route path="/" element={<Index />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/portrait" element={<Portrait />} />
                    <Route path="/wedding" element={<Wedding />} />
                    <Route path="/event" element={<Event />} />
                    <Route path="/commercial" element={<Commercial />} />
                    <Route path="/destination" element={<Destination />} />
                    <Route path="/scenery" element={<Landscape />} />
                    <Route path="/creative" element={<Creative />} />
                    <Route path="/fashion" element={<Fashion />} />
                    <Route path="/pets" element={<Pets />} />
                    <Route path="/photography" element={<Index />} />
                    <Route path="/creator-partnerships" element={<CreatorPartnerships />} />

                    <Route path="/test" element={<PhotoOverlay />} />

                    <Route
                        path="/d/admin"
                        element={
                            <RequireAdmin>
                                <DeliveryAdmin />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/d/manage"
                        element={
                            <RequireAdmin>
                                <DeliveriesManage />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/quote"
                        element={
                            <RequireAdmin>
                                <QuoteBuilder />
                            </RequireAdmin>
                        }
                    />
                    <Route path="/acorn_quote" element={<AcornQuotePage />} />
                    <Route
                        path="/panel"
                        element={
                            <RequireAdmin>
                                <Admin />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/panel/bookings"
                        element={
                            <RequireAdmin>
                                <Bookings />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/panel/feedback"
                        element={
                            <RequireAdmin>
                                <FeedbackResults />
                            </RequireAdmin>
                        }
                    />
                    <Route path="/b/:id" element={<BookingView />} />
                    <Route path="/d/:token/share" element={<DeliveryShare />} />
                    <Route path="/d/:token" element={<Delivery />} />

                    <Route
                        path="/s/admin"
                        element={
                            <RequireAdmin>
                                <SelectionAdmin />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/s/manage"
                        element={
                            <RequireAdmin>
                                <SelectionManage />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/s/results"
                        element={
                            <RequireAdmin>
                                <SelectionResults />
                            </RequireAdmin>
                        }
                    />
                    <Route path="/s/:token/cart" element={<SelectionCart />} />
                    <Route path="/s/:token" element={<Selection />} />

                    <Route
                        path="/v/admin"
                        element={
                            <RequireAdmin>
                                <VideoReviewAdmin />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/v/manage"
                        element={
                            <RequireAdmin>
                                <VideoReviewManage />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/v/results"
                        element={
                            <RequireAdmin>
                                <VideoReviewResults />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/v/audit/:id"
                        element={
                            <RequireAdmin>
                                <VideoReviewAudit />
                            </RequireAdmin>
                        }
                    />
                    <Route path="/v/:token" element={<VideoReview />} />

                    <Route
                        path="/r/admin"
                        element={
                            <RetouchRequireAdmin>
                                <RetouchReviewAdmin />
                            </RetouchRequireAdmin>
                        }
                    />
                    <Route
                        path="/r/manage"
                        element={
                            <RetouchRequireAdmin>
                                <RetouchReviewManage />
                            </RetouchRequireAdmin>
                        }
                    />
                    <Route
                        path="/r/audit/:id"
                        element={
                            <RetouchRequireAdmin>
                                <RetouchReviewAudit />
                            </RetouchRequireAdmin>
                        }
                    />
                    <Route
                        path="/r/upload/:reviewId/:batchId"
                        element={
                            <RetouchRequireAdmin>
                                <RetouchReviewUpload />
                            </RetouchRequireAdmin>
                        }
                    />
                    <Route path="/r/:token/upload/:batchId" element={<RetouchReviewUpload tokenMode />} />
                    <Route path="/r/:token" element={<RetouchReview />} />

                    <Route
                        path="/t/admin"
                        element={
                            <RequireAdmin>
                                <FileTransferAdmin />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/t/manage"
                        element={
                            <RequireAdmin>
                                <FileTransferManage />
                            </RequireAdmin>
                        }
                    />
                    <Route path="/t/:token" element={<FileTransferSession />} />
                    </Routes>
                </WhiteLabelProvider>
            </Router>
        </ConfigProvider>
    );
}

function App() {
    return (
        <LanguageProvider>
            <AppContent />
        </LanguageProvider>
    );
}

export default App;
